export type GeneralQuestionsCustomAnswers = Record<string, string | number>

export enum ValidationFieldName {
  InitialState = '',
  IndividualName = 'individualName',
  IndividualAddress = 'individualAddress',
  InvestmentAndSavingsSpecify = 'investmentsAndSavingsSpecify',
  Inheritance = 'Inheritance',
}
